import BaseOrder from './BaseOrder';

class Order extends BaseOrder {
    constructor(data) {
        super(data);
        this.id = data.id;
        this.earliestDate = this.data.event.startDate;
        this.latestDate = this.data.event.startDate;
        this.closestOrderWithMeeting = this.canStartMeeting ? this.data : undefined;
    }

    get isTicket() {
        return false;
    }

    get canStartMeeting() {
        return this.isOrderPaid &&
            !this.isEventPassed(this.data.event) &&
            this.data.service.meetingType === 'ON' &&
            this.data.event.roomId &&
            this.data.event.roomPassword

    }

    get events() {
        return [{
            ...this.data.event,
            orderId: this.id,
            isTransferEnabled: !this.isTransferAndCancelDisabled(this.data.event) && this.isOrderPaid,
            canStartMeeting: this.canStartMeeting,
            hasPassed: !this.isOrderHistory && this.isEventPassed(this.data.event)
        }];
    }

    get order() {
        return this.data;
    }

    get visits() {
        return 1;
    }

}

export default Order;
